<template>
  <div class="about">
    <h1>New QuestionnaireCatalogue</h1>
    <b-form @submit="on_submit" @reset="on_reset">
        <b-form-group label-class="text-sm-right" id="input-group-name" label="Name" label-for="input-name" description="">
            <b-form-input id="input-name" type="text" v-model="form.name" required placeholder="">
            </b-form-input>
        </b-form-group>

        <b-form-group label-class="text-sm-right" id="input-group-description" label="Name" label-for="input-description" description="">
            <b-form-input id="input-description" type="text" v-model="form.description" required placeholder="">
            </b-form-input>
        </b-form-group>

        <b-button type="submit" variant="primary">Add</b-button>

        <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data () {
    return {
      form: {
        name: '',
        description: ''
      },
      show: true
    }
  },
  methods: {
    on_submit (evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
      this.$http.post('v1/questionnairecatalogues', this.form).then(response => {
          console.log(response)
          if (response.status == 200) {
              this.$router.push('/catalogue/' + response.data.response._id + "/edit");
          }
      })
    },
    on_reset (evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.order_no = '';
      this.form.name = '';
      this.form.date = null;
      this.form.reason = '';
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => { this.show = true });
    }
  }
}
</script>
